
















































import { BetBuilderOddStatus } from '@sportOfferFederation/bet-builder/types/BetBuilderOdd';
import { SdsButtonText } from '@superbet-group/web.lib.ui-components';
import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import BetBuilderSummaryEvent from './BetBuilderSummaryEvent.vue';
import { BetBuilderPreviewSummary } from '../../types/BetBuilderPreview';

export default defineComponent({
    name: 'BetBuilderSummaryEventCard',
    props: {
        isExpandable: {
            type: Boolean,
            default: false,
        },
        isExpanded: {
            type: Boolean,
            default: false,
        },
        summary: {
            type: Object as PropType<BetBuilderPreviewSummary>,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        href: {
            type: String,
            default: null,
        },
    },
    emits: [
        'click:header',
    ],
    setup(props) {
        const showNotice = computed(() =>
            props.summary.status !== BetBuilderOddStatus.Active
            && props.summary.legs.every(({ status }) => status === BetBuilderOddStatus.Active),
        );

        return {
            showNotice,
        };
    },
    components: {
        BetBuilderSummaryEvent,
        SdsButtonText,
    },
});
